module.exports = __webpack_public_path__ + "img/section1_img2.74ae2702.png";